export default __webpack_public_path__ + "static/media/AstronomyJupiter_08.22f14570.png";